import React from "react";

import Swap from "pages/Swap";

const router = [
  {
    path: "/",
    element: <Swap />,
  },
];

export default router;
